<!-- add graph popup popup -->
<div id="forScroll" class="popup-bg add-graph-popup ">
    <div class="popup">
        <div class="popup-content">
            <h3>Add a Graph</h3>
            <div class="alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
            <div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>
            <div class="alert-warning" *ngIf="warningMessage">{{warningMessage}}</div>
        </div>
        <form class="add-graph-form" [formGroup]="addGraph">
            <div class="add-listing">
                <div class="add-detail-left">
                    <div class="step-count">
                        <span>Step 01</span>
                    </div>
                    <div class="type-text">
                        <span>Select a widget type</span><em> *</em>
                    </div>
                </div>
                <div class="add-detail-right">
                    <div class="add-checks">
                        <div class="check check-radio radio-btn">
                            <label class="custom-checkbox">
                                <input type="radio" name="Type" [checked]="showFalse"
                                    (click)="changeDropdown('timeseries')" required>
                                <em class="checkmark"><span class="check-text">Timeseries</span><i
                                        class="timeseries-icon"></i></em>
                            </label>
                        </div>
                        <div class="check check-radio radio-btn" *ngIf="cardName=='monitoring'">
                            <label class="custom-checkbox">
                                <input type="radio" name="Type" (click)="changeDropdown('compare')" required>
                                <em class="checkmark"><span class="check-text">Compare</span><i
                                        class="compare-icon"></i></em>
                            </label>
                        </div>

                        <div class="dropdown-large" (click)="changeDropdown('compare')" [ngClass]="{'active':compareValueactive}" *ngIf="cardName=='benchmarking'">
                            <span class="dropdown-placeholder">{{compareValue}}</span>
                            <span class="dropdown-arrow"></span>
                            <ul class="dropdown-large-list" *ngIf="showCompareList">
                                <li (click)="showComapreValue('simple','Bar Graph (BG)')"><i class="icon-bar-graph"></i><span>Bar Graph (BG)</span></li>
                                <li (click)="showComapreValue('clustered','Clustered Bar Graph (CBG)')"><i class="icon-bar-cluster"></i><span>Clustered Bar Graph (CBG)</span></li>
                            </ul>
                        </div>

                        <div class="check check-radio radio-btn">
                            <label class="custom-checkbox">
                                <input type="radio" name="Type" (click)="changeDropdown('histogram')" required>
                                <em class="checkmark"><span class="check-text">Distribution</span><i
                                        class="distribution-icon"></i></em>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="add-listing">
                <div class="add-detail-left">
                    <div class="step-count">
                        <span>Step 02</span>
                    </div>
                    <div class="type-text">
                        <span>Choose KPI</span><em> *</em>
                    </div>
                </div>
                <div class="add-detail-right">
                    <div class="input-row">

                        <div class="input-wrap">


                            <div class="type-text">
                                <span class="input-title">KPI Type <em> *</em></span>
                            </div>

                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiType || value=='histogram'}">
                                <app-form-select-box [options]="globalService.kpiType" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isDefaultOptionShowHidden]="'false'" [formElementName]="addGraph" [controlName]="'kpiType_select_name'" [currentSelectedValue]="addGraph['controls']['kpiType']['value']"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box>
                            </div>
                        </div>
                        <div class="input-wrap input-wrap-info">
                            <div class="type-text">
                                <span class="input-title">KPI <em> *</em></span>
                            </div>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiList}">
                                <app-form-select-box [options]="kpiList && kpiList.length>0?kpiList:globalService.kpiList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addGraph" [controlName]="'scoreName_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box>
                            </div>
                            <!-- <a href="javascript:void(0)" class="info-icon"><img src="assets/images/info-icon.svg"
                                alt=""></a> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="add-listing" *ngIf="tab1 || cardName=='monitoring'">
                <div class="add-detail-left">
                    <div class="step-count">
                        <span>Step 03</span>
                    </div>
                    <div class="type-text">
                        <span>Choose Aggregator</span><em>*</em>
                    </div>
                </div>
                <div class="add-detail-right">
                    <div class="input-row">
                        <div class="input-wrap" *ngIf="tab2">
                            <span class="input-title">Date Range</span>
                            <!-- <app-calendar (triggerOutput)="triggerOutput()"></app-calendar> -->
                            <my-date-range-picker [placeholder]="'Select'" name="mydaterange" formControlName="model" [options]="myDateRangePickerOptions" required></my-date-range-picker>
                        </div>
                        <div class="input-wrap" *ngIf="tab3">
                            <div class="type-text">
                            <span class="input-title">Aggregator On<em> *</em></span>
                        </div>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!xValueList || (compareValuepram=='simple')}">
                                <app-form-select-box [options]="xValueList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addGraph" [controlName]="'xValue_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box>
                            </div>
                        </div>

                        <div class="input-wrap" *ngIf="tab2">
                            <div class="type-text">
                                <span class="input-title">Choose Aggregator<em> *</em></span>
                            </div>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!aggregationList}">
                                <app-form-select-box [options]="aggregationList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addGraph" [controlName]="'aggregation_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <!--            <div class="add-listing">
               <div class="add-detail-left">
                   <div class="step-count">
                       <span>Step 02</span>
                   </div>
                   <div class="type-text">
                       <span>Choose KPI</span><em> *</em>
                   </div>
               </div>
               <div class="add-detail-right">
               <div class="input-row">
                   <div class="input-wrap input-wrap-info" >
                       <div class="dropdown-wrap">
                           <app-form-select-box  [options]="scoreName"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [formElementName]="addGraph" [controlName]="'scoreName'"
                            [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                            >
                        </app-form-select-box>
                       </div>
                       <a href="javascript:void(0)" class="info-icon"><img src="assets/images/info-icon.svg" alt=""></a>
                   </div>
               </div>
           </div>
           </div>
           <ng-multiselect-dropdown
  [placeholder]="'custom placeholder'"
  [data]="dropdownList"
  [(ngModel)]="selectedItems"
  [settings]="dropdownSettings"
  (onSelect)="onItemSelect($event)"
  (onSelectAll)="onSelectAll($event)"
> -->
            <div class="add-listing" *ngIf="cardName=='benchmarking'">
                <div class="add-detail-left">
                    <div class="step-count">
                        <span *ngIf="cardName=='benchmarking' && tab1">Step 04</span>
                        <span *ngIf="cardName=='benchmarking' && !tab1">Step 03</span>
                    </div>
                    <div class="type-text">
                        <span>Choose Peers</span><em> *</em>
                    </div>
                </div>
                <div class="add-detail-right">
                    <div class="input-row" *ngIf="globalService.orderType=='app'">
                        <div class="input-wrap input-wrap-info">
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!peers}">
                                <!-- <app-form-select-box [options]="peers" [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                        [formElementName]="addGraph" [controlName]="'peers_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                    </app-form-select-box> -->
                                <ng-multiselect-dropdown name="selectedItems" [placeholder]="'Select'" [data]="peers" [(ngModel)]="selectedItems" formControlName="peers" [settings]="dropdownSettings" (onDeSelect)="onDeSelect($event)" (onDeSelectAll)="onDeSelectAll($event)"></ng-multiselect-dropdown>
                            </div>
                            <a href="javascript:void(0)" class="info-icon"><img src="assets/images/info-icon.svg" alt=""></a>
                        </div>
                    </div>
                    <div class="input-row" *ngIf="globalService.orderType=='telco'">
                        <div class="input-wrap input-wrap-info">
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!peers}">
                                <!-- <app-form-select-box [options]="peers" [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                        [formElementName]="addGraph" [controlName]="'peers_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                    </app-form-select-box> -->
                                <ng-multiselect-dropdown name="selectedItems" [placeholder]="'Select'" [data]="peers" [(ngModel)]="selectedItems" formControlName="peers" [settings]="dropdownSettings" (onDeSelect)="onDeSelect($event)" (onDeSelectAll)="onDeSelectAll($event)"></ng-multiselect-dropdown>
                            </div>
                            <a href="javascript:void(0)" class="info-icon"><img src="assets/images/info-icon.svg" alt=""></a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="add-listing add-listing-condition">
                <div class="add-detail-left">
                    <div class="step-count">
                        <!-- <span *ngIf="tab1">Step 04</span>
                       <span *ngIf="!tab1">Step 03</span>
                   </div> -->
                        <span *ngIf="cardName=='benchmarking' && tab1">Step 05</span>
                        <span *ngIf="cardName=='benchmarking' && !tab1">Step 04</span>
                        <span *ngIf="cardName=='monitoring' && tab1">Step 04</span>
                        <span *ngIf="cardName=='monitoring' && !tab1">Step 03</span>
                    </div>


                    <div class="type-text">
                        <span>Choose condition</span>
                    </div>
                </div>
                <div class="add-detail-right">
                    <div class="input-row">
                        <div class="input-wrap">
                            <span class="input-title">Speed</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectSpeed}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectSpeed" formControlName="speedArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networktag" [dropDownIdKey]="'id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="addGraph"
                                    [controlName]="'networktag_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box> -->
                            </div>
                        </div>
                        <div class="input-wrap">
                            <span class="input-title">Location</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.dropdownList}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.dropdownList" formControlName="locationArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="location" [dropDownIdKey]="'id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="addGraph"
                                    [controlName]="'location_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box> -->
                            </div>
                        </div>
                    </div>
                    <div class="input-row">
                        <div class="input-wrap" *ngIf="tab3">
                            <span class="input-title">Date Range</span>
                            <!-- <app-calendar (triggerOutput)="triggerOutput()"></app-calendar> -->
                            <my-date-range-picker [placeholder]="'Select'" name="mydaterange" [options]="myDateRangePickerOptions" formControlName="model" required></my-date-range-picker>
                        </div>

                        <div class="input-wrap">
                            <span class="input-title">Time Window</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectTimeWindow || !tab3 }">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectTimeWindow" formControlName="timeWindowArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="timeWindow" [isAllOptionShow]="true"
                                    [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addGraph"
                                    [controlName]="'timeWindow_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box> -->

                            </div>
                        </div>
                        <div class="input-wrap" *ngIf="!tab3 && globalService.orderType=='app'">
                            <span class="input-title">Choose Telcos</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectNetwork}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectNetwork" formControlName="networkArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networks" [dropDownIdKey]="'Network_id'"
                                    [dropdownLabel]="'list'" [isAllOptionShow]="true" [formElementName]="addGraph"
                                    [controlName]="'networks_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box> -->
                            </div>
                        </div>
                        <div class="input-wrap" *ngIf="!tab3 && globalService.orderType=='telco'">
                            <span class="input-title">Choose Apps</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiselectAppsList}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiselectAppsList" formControlName="appsArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networks" [isAllOptionShow]="true"
                                    [dropDownIdKey]="'Network_id'" [dropdownLabel]="'list'"
                                    [formElementName]="addGraph" [controlName]="'networks_select_name'"
                                    [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box> -->
                            </div>
                        </div>
                    </div>
                    <div class="input-row">
                        <div class="input-wrap">
                            <span class="input-title">Device Category</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectDeviceCategory}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectDeviceCategory" formControlName="deviceCategoryArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="deviceCategory" [isAllOptionShow]="true"
                                    [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="addGraph"
                                    [controlName]="'deviceCategory_select_name'" [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box> -->
                            </div>
                        </div>
                        <div class="input-wrap">
                            <span class="input-title">Widget Name</span>
                            <input type="text" placeholder="mywidget1" name="widgetName" formControlName="widgetName">
                        </div>
                    </div>
                    <div class="input-row">
                        <div class="input-wrap" *ngIf="tab3 && globalService.orderType=='app'">
                            <span class="input-title">Choose Telcos</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectNetwork}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectNetwork" formControlName="networkArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networks" [isAllOptionShow]="true"
                                    [dropDownIdKey]="'Network_id'" [dropdownLabel]="'list'"
                                    [formElementName]="addGraph" [controlName]="'networks_select_name'"
                                    [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box> -->
                            </div>
                        </div>
                        <div class="input-wrap" *ngIf="tab3 && globalService.orderType=='telco'">
                            <span class="input-title">Choose Apps</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiselectAppsList}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiselectAppsList" formControlName="appsArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box [options]="networks" [isAllOptionShow]="true"
                                    [dropDownIdKey]="'Network_id'" [dropdownLabel]="'list'"
                                    [formElementName]="addGraph" [controlName]="'networks_select_name'"
                                    [addCurrentSelectedValue]="false"
                                    (currentSelectionChange)="changeSelection($event)">
                                </app-form-select-box> -->
                            </div>
                        </div>
                        <div class="input-wrap">
                            <!-- <span class="input-title">Stream Type</span>
                            <div class="check-bar">
                                <div class="check check-radio">
                                    <label class="custom-checkbox">
                                        <input type="radio" name="stream" formControlName="stream" value="true" required>
                                        <em class="checkmark"></em>
                                        <span class="check-text">Live</span>
                                    </label>
                                </div>
                                <div class="check check-radio">
                                    <label class="custom-checkbox">
                                        <input type="radio" name="stream" formControlName="stream" value="false" required>
                                        <em class="checkmark"></em>
                                        <span class="check-text">VOD</span>
                                    </label>
                                </div>
                            </div> -->
                            <span class="input-title">Choose Platform</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectPlatform}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectPlatform" formControlName="platformArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>

                            </div>
                        </div>
                        
                        <div class="input-wrap" *ngIf="tab1 && !tab3">
                            <span class="input-title">Application Version</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectAppVersion}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectAppVersion" formControlName="appVersionArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box  [options]="app_version"
                                [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                                [isAllOptionShow]="true"
    
                                [formElementName]="addCard" [controlName]="'appversion_select_name'"
                                [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                >
                            </app-form-select-box> -->
                            </div>
    
                        </div>
                    </div>

                    <div class="input-row" *ngIf="tab3">
                        <div class="input-wrap">
                            <span class="input-title">Application Version</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectAppVersion}">
                                <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectAppVersion" formControlName="appVersionArray" [settings]="dropdownSettings">
                                </ng-multiselect-dropdown>
                                <!-- <app-form-select-box  [options]="app_version"
                                [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                                [isAllOptionShow]="true"
    
                                [formElementName]="addCard" [controlName]="'appversion_select_name'"
                                [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                >
                            </app-form-select-box> -->
                            </div>
    
                        </div>
                    </div>

                </div>
            </div>
            <div class="popup-links text-right">
                <button class="btn btn-light" (click)="forPopupClose()">close</button>
                <button class="btn btn-dark" (click)="submitData($event)">add score</button>
            </div>
        </form>
    </div>